import $ from "jquery"
import BreadcrumbsApp from "./BreadcrumbsApp.vue";
import AccountMenu from "./AccountMenu.vue";
import { CreateVueAppWithDirectives } from "../../src/VueWrapper";

const app = CreateVueAppWithDirectives(BreadcrumbsApp);
app.mount('#breadcrumbs-app');

const accMenuApp = CreateVueAppWithDirectives(AccountMenu);
accMenuApp.mount('#accountmenu-app');

$(`a[href='${window.location.pathname}']`).addClass("currentPage")

$("#menuBtnCheckbox").on("click", (e) => {
    if((e.target as HTMLInputElement).checked) {
        $(".mainBox").addClass("menuOpen");
    }
    else {
        $(".mainBox").removeClass("menuOpen");
    }
});